module.exports = __webpack_public_path__ + "img/line5.6b6d0d04.png";